import React, { useEffect, useState } from "react";
import { Button } from "../../Components/Tags/Tags";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";
import {
  RequstFundService,
  retriveFundService,
  SlipPreviewService,
} from "../../Services/AddBankAC.js/fundRequest";
import SlipViewModal from "./SlipViewModal";
import { FaInbox } from "react-icons/fa";
import { IoIosCopy } from "react-icons/io";
import moment from "moment";
import { FaInfoCircle } from "react-icons/fa";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import Loader from "../../Loader";
import PaginationData from "../../Components/PaginationData";
import { BanknoteArrowDown, InfoIcon } from "lucide-react";
import { MoneySharp } from "@mui/icons-material";

const AddFund = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [paySlip, setPaySlip] = useState(null);
  const [paymode, setPaymode] = useState("");
  const [amount, setAmount] = useState("");
  const [utrNo, setUtrNo] = useState("");

  const [txnDate, setTxnDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Format YYYY-MM-DD
  });

  const [fundData, setFundData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [errors, setErrors] = useState({});
  const [filename, setFileName] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  const openModal = () => setIsModalOpen(true);

  const closeModal = () => {
    setFileName("");
    setImageUrl("");
    setIsModalOpen(false);
  };

  async function SlipPreview() {
    const response = await SlipPreviewService(filename);
    setImageUrl(response.dataUri);
    return;
  }
  useEffect(() => {
    SlipPreview();
  }, [isModalOpen]);

  const handleDateChange = (e) => {
    setTxnDate(e.target.value);
  };

  // Validate Form Input
  const validateForm = () => {
    const newErrors = {};

    // Paymode is required
    if (!paymode) newErrors.paymode = "Paymode is required";

    // Validate PaySlip & UTR No only for Online Payment
    if (paymode === "online") {
      if (!paySlip) {
        newErrors.slip = "PaySlip is required.";
      } else if (paySlip.size > 1024000) {
        newErrors.slip = "PaySlip must be smaller than 1 MB.";
      }

      if (!utrNo) newErrors.utrNo = "Utr No is required.";
    }

    // Amount Validation for all paymodes
    const amt = Number(amount);

    if (!amt || isNaN(amt)) {
      newErrors.amount = "Amount must be a valid number.";
    } else if (amt < 1000) {
      newErrors.amount =
        paymode === "qr"
          ? "Amount must be at least ₹1000 for QR."
          : "Amount must be at least ₹1000.";
    }

    // Txn Date Validation for all paymodes
    // if (!txnDate) newErrors.txnDate = 'Txn Date must be a valid date.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    if (!validateForm()) return;

    try {
      setIsLoading(true);
      const txnDate2 = new Date(txnDate).toLocaleDateString("en-CA");
      const formData = new FormData();
      formData.append("slip", paySlip);
      formData.append("mode", paymode);
      formData.append("amount", amount);
      formData.append("utr", utrNo);
      formData.append("txn_date", txnDate2);

      const response = await RequstFundService(formData);

      if (response.status === 422) {
        showErrorToast(response.data?.error || "Validation Failed");
        return;
      }

      if (response.status === 500) {
        showErrorToast(
          response.data?.error ||
            "Internal Server Error. Please try again later.",
        );
        return;
      }

      const paymentUrl = response.data?.payment_url;
      const walletAmount = response.data?.wallet?.amount || 0;

      if (paymode === "qr" && walletAmount < 1000) {
        showErrorToast(
          response.data?.error || "Amount must not be less than 1000",
        );
        return;
      }

      // Call RetrieveFundData first before resetting the form
      await RetrieveFundData();

      resetForm();
      showSuccessToast(response.data?.message || "Fund request added");

      // Redirect to Payment URL if available
      if (paymentUrl) {
        window.location.href = paymentUrl;
      }
    } catch (error) {
      if (error.response) {
        showErrorToast(
          error.response.data?.message || `Error: ${error.response.status}`,
        );
      } else if (error.request) {
        showErrorToast(
          "No response received from server. Please check your network.",
        );
      } else {
        showErrorToast(error.message || "Something went wrong.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setPaySlip(null);
    setPaymode("");
    setAmount("");
    setUtrNo("");
    setTxnDate("");
  };

  // Retrive Fund Data
  const RetrieveFundData = async (page = currentPage) => {
    try {
      setIsLoading(true);
      const response = await retriveFundService(page);
      if (response && response.data) {
        setFundData(response.data.data || []);
        setPaginationData(response.data.pagination || {});
        setCurrentPage(response.data.pagination.current_page || 1);
        setLastPage(response.data.pagination.last_page || 1);
      }
    } catch (error) {
      showErrorToast(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    RetrieveFundData();
  }, [currentPage]);
  // ENd

  function handlePage(page) {
    setCurrentPage(page);
  }

  const handleCopy = (orderId) => {
    if (!orderId) {
      showErrorToast("No Order ID available to copy!");
      return;
    }
    // Create a temporary textarea to copy the text
    const tempTextarea = document.createElement("textarea");
    tempTextarea.value = orderId;
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    showSuccessToast("Copied to clipboard!");
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading="Add Fund" />

      <div className="grid grid-cols-1 py-4 items-stretch gap-4 justify-items-stretch md:grid-cols-2">
        {/* Form starts here */}
        <div className="flex w-full rounded-3xl overflow-hidden shadow-[0_30px_80px_-15px_rgba(0,0,0,0.6)] flex-col font-sans pb-2 justify-start items-center gap-6">
          {/* HEADER STRIP */}
          <div className="bg-gradient-to-br w-full from-purple-700 via-blue-700 to-blue-600 px-6 py-2 flex items-center gap-3">
            <div className="h-11 w-11 rounded-full bg-black/30 backdrop-blur flex items-center justify-center">
              <BanknoteArrowDown className="h-6 w-6 text-white" />
            </div>
            <h2 className="text-white text-xl font-extrabold tracking-widest uppercase">
              Add Fund
            </h2>
          </div>

          <div className="flex w-full flex-col font-sans px-4 md:px-8 lg:px-12 py-2 justify-start items-start gap-6 md:mt-2">
            {/* Pay Mode Selection */}
            <div className="w-full flex flex-col gap-2">
              <label
                htmlFor="paymode"
                className="block font-sans font-semibold"
              >
                Select Pay Mode<span className="text-red-700 font-bold">*</span>
              </label>
              <select
                className="
                  w-full rounded-xl border border-gray-600 bg-white/70
                  px-4 pr-2 py-3 text-[16px] text-gray-900
                  shadow-sm backdrop-blur
                  transition-all duration-200
                  focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                  focus:outline-none
                  disabled:cursor-not-allowed disabled:opacity-60
                "
                name="paymode"
                id="paymode"
                onChange={(e) => setPaymode(e.target.value)}
              >
                <option value="">Select Pay Mode</option>
                <option value="online">Bank Transfer</option>
                <option value="qr">UPI</option>
              </select>

              {paymode
                ? null
                : errors.paymode && (
                    <p className="text-red-600 text-sm font-mono">
                      {errors.paymode}
                    </p>
                  )}
            </div>

            {/* Conditionally Show Slip Field (Only for Online) */}
            {paymode === "online" && (
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="slip" className="block font-sans font-semibold">
                  Upload PaySlip
                  <span className="text-red-700 font-bold">*</span>
                </label>
                <input
                  type="file"
                  name="slip"
                  id="slip"
                  onChange={(e) => setPaySlip(e.target.files[0])}
                  className="px-2 border border-blue-600 rounded-md"
                />
                {errors.slip && (
                  <p className="text-red-600 text-sm font-mono">
                    {errors.slip}
                  </p>
                )}
              </div>
            )}

            {/* Amount Field */}
            <div className="w-full flex flex-col gap-2">
              <label htmlFor="amount" className="block font-sans font-semibold">
                Amount<span className="text-red-700 font-bold">*</span>
              </label>
              <input
                type="text"
                name="amount"
                id="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Eg 1000-100000"
                className="
                    w-full rounded-xl border border-gray-600 bg-white/70
                    px-4 py-3 text-[16px] text-gray-900
                    placeholder:text-gray-400
                    shadow-sm backdrop-blur
                    transition-all duration-200
                    focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                    focus:outline-none
                    disabled:cursor-not-allowed disabled:opacity-60
                  "
              />

              {Number(amount) >= 1000
                ? null
                : errors.amount && (
                    <p className="text-red-600 text-sm font-mono">
                      {errors.amount}
                    </p>
                  )}
            </div>

            {/* Conditionally Show UTR No Field (Only for Online) */}
            {paymode === "online" && (
              <div className="w-full flex flex-col gap-2">
                <label
                  htmlFor="utrNo"
                  className="block font-sans font-semibold"
                >
                  UTR No<span className="text-red-700 font-bold">*</span>
                </label>
                <input
                  type="text"
                  name="utrNo"
                  id="utrNo"
                  value={utrNo}
                  onChange={(e) => setUtrNo(e.target.value)}
                  placeholder="Enter UTR No."
                  className="
                      w-full rounded-xl border border-gray-800 bg-white/70
                      px-4 py-3 text-sm text-gray-900
                      placeholder:text-gray-400
                      shadow-sm backdrop-blur
                      transition-all duration-200
                      focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                      focus:outline-none
                      disabled:cursor-not-allowed disabled:opacity-60
                    "
                />
                {utrNo
                  ? null
                  : errors.utrNo && (
                      <p className="text-red-600 text-sm font-mono">
                        {errors.utrNo}
                      </p>
                    )}
              </div>
            )}

            {/* Transaction Date Field */}
            <div className="w-full flex flex-col gap-2">
              <label
                htmlFor="txnDate"
                className="block font-sans font-semibold"
              >
                Txn Date<span className="text-red-700 font-bold">*</span>
              </label>
              <input
                type="date"
                name="txnDate"
                id="txnDate"
                value={txnDate}
                onChange={handleDateChange}
                className="
                  w-full rounded-xl border border-gray-600 bg-white/70
                  px-4 py-3 text-sm text-gray-900
                  shadow-sm backdrop-blur
                  transition-all duration-200
                  focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                  focus:outline-none
                "
              />
              {errors.txnDate && (
                <p className="text-red-600 text-sm font-mono">
                  {errors.txnDate}
                </p>
              )}
            </div>

            <div className="w-full ">
              <Button
                color="primary"
                onClick={handlesubmit}
                disabled={isLoading}
                className="w-full sm:w-auto mt-5 bg-gradient-to-r from-cyan-500 to-blue-800 text-white font-semibold rounded-md px-3 py-1 shadow-lg hover:from-blue-900 hover:to-blue-400"
              >
                {isLoading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </div>
          <div className="bg-gradient-to-r from-indigo-600 via-purple-500 to-blue-500 h-1" />
        </div>

        {/* instructions */}

        <div className="w-full flex justify-center items-stretch px-4 ">
          <div className="relative w-full">

            {/* CARD */}
            <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_80px_-15px_rgba(0,0,0,0.6)]">
              {/* HEADER STRIP */}
              <div className="bg-gradient-to-br from-purple-700 via-blue-700 to-blue-600 px-6 py-2 flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-black/30 backdrop-blur flex items-center justify-center">
                  <InfoIcon className="h-6 w-6 text-white animate-bounce" />
                </div>
                <h2 className="text-white text-xl font-extrabold tracking-widest uppercase">
                  Important Instructions
                </h2>
              </div>

              {/* BODY */}
              <div className="bg-gradient-to-br from-[#dcdddf] via-[#c7c8c7] to-gray-200 px-6 py-6 text-black">
                <div className="space-y-2 text-[16px]">
                  <div className="space-y-1">
                    <p className="flex gap-3 items-start">
                      <span className="h-2.5 w-3.5 mt-2 rounded-full bg-purple-700" />
                      <span>
                        Use only your{" "}
                        <b className="text-purple-700">
                          own bank account / UPI ID
                        </b>{" "}
                        that is registered in your company or individual name.
                      </span>
                    </p>
                    <p className="ml-6">
                      ➜ Third-party or{" "}
                      <b className="text-purple-700">unknown UPI payments</b>{" "}
                      may be rejected or put on hold.
                    </p>
                  </div>

                  <div className="space-y-1">
                    <p className="flex gap-3 items-start">
                      <span className="h-2.5 w-2.5 mt-2 rounded-full bg-purple-700" />
                      <span>After successful UPI payment:</span>
                    </p>
                    <p className="ml-6">
                      • <b className="text-purple-700">Wallet balance</b> is
                      usually updated automatically within a few minutes
                    </p>
                    <p className="ml-6">
                      • In rare cases, it may take up to 24 working hours due to
                      bank or <b className="text-purple-700">NPCI delays</b>
                    </p>
                  </div>

                  <div className="space-y-1">
                    <p className="flex gap-3 items-start">
                      <span className="h-2.5 w-3.5 mt-2 rounded-full bg-purple-700" />
                      <span>
                        If the amount is debited from your bank but not
                        reflected in the wallet:
                      </span>
                    </p>
                    <p className="ml-6">
                      •{" "}
                      <b className="text-purple-700">
                        Keep the UPI transaction ID (UTR)
                      </b>
                    </p>
                    <p className="ml-6">
                      • Raise a support ticket or{" "}
                      <b className="text-purple-700">contact IDSPay</b> support
                      with payment details
                    </p>
                  </div>

                  <p className="flex gap-3 items-start">
                    <span className="h-2.5 w-3.5 mt-2 rounded-full bg-purple-700" />
                    <span>
                      <b className="text-purple-700">
                        Do not attempt multiple payments
                      </b>{" "}
                      for the same request unless advised by{" "}
                      <b className="text-purple-700">IDSPay support</b>.
                    </span>
                  </p>
                </div>
              </div>

              {/* FOOTER STRIP */}
              <div className="bg-gradient-to-r from-indigo-600 via-purple-500 to-blue-500 h-1" />
            </div>
          </div>
        </div>
      </div>

      {fundData?.length > 0 ? (
        <>
          <div className="overflow-x-auto mt-4 hidden md:block">
            <table className="min-w-full divide-y divide-gray-200 ">
              <thead className="bg-blue-600 text-white">
                <tr className="font-sans ">
                  <th className="border border-white">SNo</th>
                  <th className="p-2 border border-white">Request Date</th>
                  <th className="p-2 border border-white">Status</th>
                  <th className="p-2 border border-white">View</th>
                  <th className="p-2 border border-white">Paymode</th>
                  <th className="p-2 border border-white">Amount</th>
                  <th className="p-2 border border-white">Order ID </th>
                  <th className="p-2 border border-white">UTR/RRN</th>
                  <th className="p-2 border border-white">
                    Wallet Transaction Id
                  </th>
                </tr>
              </thead>
              <tbody className="text-center ">
                {fundData.map((item, index) => (
                  <tr key={index} className="border-b-blue-900">
                    <td className="p-1 border  shadow-inner shadow-blue-600 font-bold">
                      {(currentPage - 1) * paginationData?.per_page + index + 1}
                    </td>
                    <td className="p-1 border shadow-inner shadow-blue-400">
                      {moment(item?.created_at).format("DD/MM/YYYY")}
                    </td>
                    <td className="p-1 border shadow-inner shadow-blue-400">
                      <div className="flex justify-between items-center relative">
                        <button
                          className={`px-1 py-1 text-white rounded ${
                            item?.status?.value === "approved"
                              ? "bg-green-600 first-letter:uppercase text-xs"
                              : item?.status?.value === "pending"
                                ? "bg-yellow-500 first-letter:uppercase text-xs"
                                : "bg-red-500 first-letter:uppercase text-xs"
                          }`}
                        >
                          {item?.status?.value}
                        </button>

                        <div className="relative group">
                          <FaInfoCircle
                            className="cursor-pointer animate-pulse"
                            size={20}
                          />
                          {/* Tooltip for remarks */}
                          <div className="absolute left-3 bottom-2 w-max bg-gray-800 text-white text-sm px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {item?.remarks || "No remarks"}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td className="p-1 border shadow-inner shadow-blue-400">
                      <button
                        onClick={openModal}
                        className="bg-green-500 text-white px-1 py-0 rounded-lg"
                      >
                        Slip{" "}
                      </button>
                    </td>
                    <td className="p-1 border shadow-inner shadow-blue-400">
                      {item?.mode}
                    </td>
                    <td className="p-1 boder shadow-inner shadow-blue-400">
                      {item?.amount}
                    </td>

                    {/* Order ID TD - without tooltip now */}
                    <td className="p-1 shadow-inner shadow-blue-400 text-sm">
                      {item?.qr_payment?.order_status_response
                        ? (() => {
                            try {
                              const parsed = JSON.parse(
                                item.qr_payment.order_status_response,
                              );
                              return parsed?.data?.order_id || "N/A";
                            } catch (e) {
                              return "N/A";
                            }
                          })()
                        : "N/A"}
                    </td>

                    {/* UTR TD - with tooltip added here */}
                    <td className="p-1 border shadow-inner shadow-blue-400 text-sm flex items-center gap-1 relative group">
                      {item?.qr_payment?.order_status_response
                        ? (() => {
                            try {
                              const parsed = JSON.parse(
                                item.qr_payment.order_status_response,
                              );
                              return (
                                <>
                                  {parsed?.data?.utr || "N/A"}

                                  <div className="relative ml-1">
                                    <FaInfoCircle
                                      className="text-blue-600 cursor-pointer hover:text-blue-800 animate-pulse border rounded-lg"
                                      size={20}
                                    />

                                    {/* Tooltip */}
                                    <div className="absolute z-20 top-3 left-4 hidden group-hover:block bg-white text-gray-900 text-sm p-1 rounded-lg shadow-xl w-max whitespace-pre-line border transition-all duration-100 font-medium">
                                      <div>
                                        <span className="font-semibold">
                                          Customer:
                                        </span>{" "}
                                        {parsed?.data?.customer_name}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Amount:
                                        </span>{" "}
                                        ₹{parsed?.data?.txn_amount}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Date:
                                        </span>{" "}
                                        {parsed?.data?.txn_date}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Status:
                                        </span>{" "}
                                        {parsed?.data?.txn_status}
                                      </div>
                                      <div>
                                        <span className="font-semibold">
                                          Note:
                                        </span>{" "}
                                        {parsed?.data?.description}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            } catch (e) {
                              return "N/A";
                            }
                          })()
                        : "N/A"}
                    </td>

                    <td className="p-1 border shadow-inner shadow-blue-400 text-sm">
                      <div className="flex justify-evenly">
                        {item?.transaction_ids?.length > 0
                          ? item?.transaction_ids[0]?.order_id
                          : "N/A"}
                        <IoIosCopy
                          onClick={() =>
                            handleCopy(
                              item?.transaction_ids?.length > 0
                                ? item?.transaction_ids[0]?.order_id
                                : "N/A",
                            )
                          }
                          size={20}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="md:hidden mt-2 space-y-2">
            {fundData.map((item, index) => {
              const parsed = item?.qr_payment?.order_status_response
                ? (() => {
                    try {
                      return JSON.parse(item.qr_payment?.order_status_response);
                    } catch {
                      return {};
                    }
                  })()
                : {};

              return (
                <div
                  key={index}
                  className="bg-white shadow-lg rounded-xl p-2 border border-blue-200"
                >
                  <div className="flex justify-between text-sm">
                    <span>
                      SNo:{" "}
                      {(currentPage - 1) * paginationData?.per_page + index + 1}
                    </span>
                    <p>
                      <strong>Req Date:</strong>
                      {moment(item?.created_at).format("DD/MM/YYYY")}
                    </p>
                  </div>
                  <div className="mt-2">
                    <div className="flex justify-between text-sm">
                      <p>
                        <strong>Status:</strong>{" "}
                        <span
                          className={`px-1 py-0 rounded text-white ${item.status?.value === "approved" ? "bg-green-500" : item.status?.value === "pending" ? "bg-yellow-500" : "bg-red-500"}`}
                        >
                          {item?.status?.value}
                        </span>
                      </p>
                      <p>
                        <strong>Paymode:</strong> {item?.mode}
                      </p>
                    </div>
                    <div className="flex justify-between text-sm">
                      <p>
                        <strong>Amount:</strong> ₹{item?.amount}
                      </p>
                      <p>
                        <strong>Order ID:</strong>{" "}
                        {parsed?.data?.order_id || "N/A"}
                      </p>
                    </div>
                    <p className="text-sm">
                      <strong>UTR:</strong> {parsed?.data?.utr || "N/A"}
                    </p>
                    <p className="text-sm">
                      <strong>Wallet Txn ID:</strong>{" "}
                      {item?.transaction_ids?.[0]?.order_id || "N/A"}
                    </p>
                    <div className="flex justify-between text-sm">
                      <p
                        className="text-blue-500 text-sm mt-1 cursor-pointer"
                        onClick={openModal}
                      >
                        View Slip
                      </p>
                      <button
                        onClick={() =>
                          handleCopy(
                            item?.transaction_ids?.[0]?.order_id || "N/A",
                          )
                        }
                        className="mt-2 text-sm text-blue-600 underline"
                      >
                        Copy Txn ID
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center mt-5">
          <FaInbox className="text-3xl" />
          <p>No Fund Data Available</p>
        </div>
      )}

      <PaginationData
        currentPage={currentPage}
        lastPage={lastPage}
        handlePage={handlePage}
      />
      <SlipViewModal
        isOpen={isModalOpen}
        onClose={closeModal}
        imageUrl={imageUrl}
      />
    </>
  );
};

export default AddFund;
